// var nextButton  = document.querySelector('.button-next');
// var prevButton  = document.querySelector('.button-prev');

// nextButton.addEventListener("click", function() {
//   var activeSlide = document.querySelector('.feature-slide.active');
//       featureSlide = document.querySelector('.feature-slide');
  
//   activeSlide.classList.remove('active');
//   activeSlide.nextElementSibling.classList.add('active');  
// });

// prevButton.addEventListener("click", function() {
//   var activeSlide = document.querySelector('.feature-slide.active');
//       featureSlide = document.querySelector('.feature-slide');
  
//   activeSlide.classList.remove('active');
//   activeSlide.prevElementSibling.classList.add('active');  
  
// });

$(".button-next").click(function() {
  var $current = $(".feature-slide.active");
  var $next = $current.next(".feature-slide");
  
  $current.removeClass("active").attr({"aria-hidden": "true", "tabindex": -1});
  if ($next.length) {
    $next.addClass("active").attr({"aria-hidden": "false", "tabindex": 0});
  } else {
    $(".feature-slide").first().addClass("active").attr({"aria-hidden": "false", "tabindex": 0});
  }
});

$(".button-prev").click(function() {
  var $current = $(".feature-slide.active");
  var $prev = $current.prev(".feature-slide");
  
  $current.removeClass("active").attr({"aria-hidden": "true", "tabindex": -1});
  if ($prev.length) {
    $prev.addClass("active").attr({"aria-hidden": "false", "tabindex": 0});
  } else {
    $(".feature-slide").last().addClass("active").attr({"aria-hidden": "false", "tabindex": 0});
  }
});
